'use client';

import { c as _c } from "react/compiler-runtime";
import { ABSmartlyProvider } from '@cc-shopping/platform-absmartly/context/ABSmartlyProvider';
import type { ABSmartlyContextData } from '@cc-shopping/platform-absmartly/types/absmartly';
import type { ABTestVariantResult } from '@cc-shopping/platform-absmartly/utils/variants';
import { AnalyticsPageView as SegmentPageView } from '@cc-shopping/platform-analytics/AnalyticsPageView';
import { NerdWalletThemeProvider } from '@cc-shopping/ui/composites/NerdWalletThemeProvider';
import { Container, CssBaseline } from '@mui/material';
import { ExperimentNav } from 'src/features/ExperimentNav';
import { CompassPageViewRegistration } from 'src/shared/analytics/CompassPageViewRegistration';
import Compare from './components';
export function CompareEntry(t0) {
  const $ = _c(6);
  const {
    abSmartlyContextData,
    staticExperimentResult,
    staticExperimentName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CssBaseline />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SegmentPageView name="cc_compare_page"><CompassPageViewRegistration><NerdWalletThemeProvider>{t1}<Container disableGutters={true}><Compare /></Container></NerdWalletThemeProvider></CompassPageViewRegistration></SegmentPageView>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const childrenProviders = t2;
  let t3;
  if ($[2] !== abSmartlyContextData || $[3] !== staticExperimentName || $[4] !== staticExperimentResult) {
    t3 = abSmartlyContextData ? <ABSmartlyProvider contextData={abSmartlyContextData} staticExperimentResult={staticExperimentResult}>{childrenProviders}{staticExperimentName && <ExperimentNav staticExperimentName={staticExperimentName} />}</ABSmartlyProvider> : childrenProviders;
    $[2] = abSmartlyContextData;
    $[3] = staticExperimentName;
    $[4] = staticExperimentResult;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}